var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"hv",attrs:{"controls":"controls"}},[_c('source',{attrs:{"src":_vm.src,"poster":_vm.poster,"type":"video/mp4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }